export default __webpack_public_path__ + "static/media/Marino Magliani.c6cfc9c3.jpg";